export const SET_CORPORATION_MANAGERS = "SET_CORPORATION_MANAGERS"
